<div class="content-wrapper">
  <div style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 8px;">
    <div>
      <div class="fs-24 fw-700 mb-4">eXplorer</div>
      <div class="fs-18 fw-500">Insights Dashboard</div>
    </div>

<!--    <div>-->
<!--      <div style="display: flex; align-items: center; gap: 8px">-->
<!--        <i class="pi pi-history" style="font-size: 0.9rem"></i>-->
<!--        <div class="fs-14">Last Refresh: {{lastRefresh | dateTime}}</div>-->
<!--      </div>-->
<!--    </div>-->
  </div>

  <div class="mt-16 mb-16" style="overflow: auto">
    <p-selectbutton
      [options]="dateRangeOptions"
      [(ngModel)]="dateRangeFilter"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      (onChange)="onChangeDateRange()"
    >
      <ng-template #item let-filterItem>
        <div style="display: flex; align-items: center; gap: 8px; white-space: nowrap;">
          <i [class]="filterItem.icon"></i>
          {{filterItem.label}}
        </div>
      </ng-template>
    </p-selectbutton>
  </div>

  <p-card header="Withdrawal Health Check" class="table-card">
    <p-table
      class="withdrawal-health-check-table"
      [value]="data"
      [lazy]="true"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="totalResults"
      [first]="first"
      [pageLinks]="3"
      [scrollable]="true"
      [rowHover]="true"
      [loading]="loading"
      sortField="risk"
      [sortOrder]="-1"
      (onLazyLoad)="onLazyLoad($event)"
      [tableStyle]="{ 'min-width': '50rem' }"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} of {totalRecords}"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="agentName" style="min-width: 200px;">
            <div style="display: flex; align-items: center; gap: 4px">
              Agent
              <p-sortIcon field="agentName" />
            </div>
          </th>
          <th pSortableColumn="onMarketCount" style="max-width: 200px">
            <div style="display: flex; align-items: center; gap: 4px">
              On Market
              <p-sortIcon field="onMarketCount" />
            </div>
          </th>
          <th pSortableColumn="withdrawnCount" style="max-width: 200px">
            <div style="display: flex; align-items: center; gap: 4px">
              Withdrawn
              <p-sortIcon field="withdrawnCount" />
            </div>
          </th>
          <th pSortableColumn="withdrawnPercentage" style="max-width: 200px">
            <div style="display: flex; align-items: center; gap: 4px">
              %
              <p-sortIcon field="withdrawnPercentage" />
            </div>
          </th>
          <th pSortableColumn="risk" class="risk-column-header" style="width: 150px">
            <div style="display: flex; align-items: center; gap: 4px">
              Risk
              <p-sortIcon field="risk" />
            </div>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr (click)="onClickRow(row)">
          <td>
            <div style="display: flex; gap: 12px; align-items: center">
              <p-avatar
                [image]="row?.agentAvatar"
                [label]="row?.agentAvatar ? undefined : row?.agentInitials"
                class="agent-avatar"
                size="normal"
                shape="circle"
              />

              <div>
                <div class="fw-500">{{row.agentName}}</div>
                <div class="fs-14">{{row.teamName}}</div>
              </div>
            </div>
          </td>
          <td>{{ row.onMarketCount | number }}</td>
          <td>{{ row.withdrawnCount | number }}</td>
          <td>{{ row.withdrawnPercentage }}%</td>
          <td>
            <div style="display: flex; align-items: center; gap: 12px;">
              @if (row.risk === RiskEnum.Low) {
                <p-tag severity="success" value="Low Risk" />
              } @else if (row.risk === RiskEnum.Medium) {
                <p-tag severity="warn" value="Med Risk" />
              } @else {
                <p-tag severity="danger" value="High Risk" />
              }
              <i class="pi pi-chevron-right"></i>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td colspan="5">No agents found.</td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
